import cx from 'classnames'
import { useObjectRef } from '@react-aria/utils'
import { forwardRef, InputHTMLAttributes } from 'react'
import Styles from './WorkflowBuilderItem.module.scss'
import { useKeyboard } from '@react-aria/interactions'

export const AutoResizingTextInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ value, onChange }, fRef) => {
    const ref = useObjectRef(fRef)

    const { keyboardProps } = useKeyboard({
      onKeyDown: ({ key }) => {
        if (key === 'Enter') {
          ref.current?.blur()
        }
      },
    })

    return (
      <div className={Styles.autoResizingTextField}>
        <div className={Styles.spacerText} aria-hidden>
          {value || <>&nbsp;</>}
        </div>
        <input
          type="text"
          ref={ref}
          {...keyboardProps}
          className={cx(Styles.textField, Styles.name)}
          value={value}
          onChange={onChange}
        />
      </div>
    )
  },
)
